export default "__VITE_ASSET__Bzz18_Ga__"